<template>
  <b-container>
    <div class="py-5 text-center">
      <h1 class="display-1"> 404 </h1>
      <h2 class="mb-4">Oops, the page can not be found</h2>
      <b-button href="/">Go to home</b-button> 
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'page404',

  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
